import { Observable, Subject } from "rxjs";

const snacbarService = {
  message: new Subject<string>(),
  errorMessage: new Subject<string>(),
  getMessage: function (): Observable<string> {
    return snacbarService.message.asObservable();
  },
  getErrorMessage: function (): Observable<string> {
    return snacbarService.errorMessage.asObservable();
  },
  sendMessage: function (message: string) {
    snacbarService.message.next(message);
  },
  sendErrorMessage: function (message: string) {
    snacbarService.errorMessage.next(message);
  },
};
export default snacbarService;
